'use client';

import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="font-display text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="font-display text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          The page you are looking for does not exist.
        </p>
        <Button onClick={() => router.push('/')}>
          Go Back Home
        </Button>
      </div>
    </div>
  );
}

